module.exports = __webpack_public_path__ + "img/shot_img121301.b9d40112.gif";